import { isMobile, withOrientationChange } from "react-device-detect"

import TemplateMain from "components/TemplateMain"
import DesktopPage from "components/DesktopPage"
import Landscape from "components/Landscape"
import store from "store"
import { setState } from "store/ui"
import { useEffect } from "react"

let Home = ({ isLandscape }) => {
  useEffect(() => {
    store.dispatch(setState({ isLandscape }))
  }, [isLandscape])

  return (
    <>
      {(isMobile || window.location.search.includes("desktop")) && (
        <TemplateMain />
      )}
      {!isMobile && <DesktopPage />}
      {isLandscape && <Landscape />}
      <TemplateMain />
    </>
  )
}

Home = withOrientationChange(Home)

export default Home
